<div class="maintenance" *ngIf="maintenance">
    <div class="container">
        <h1 class="title">BML Shopping Center is Currently under maintenance</h1>
        <p class="description">The site would be available on  {{maintenance.endTime | date: 'full'}} </p>
        <p>For any emergency please contact BML sales team at sales&#64;bmlcenter.com or call us at +1 (888) 896-2698</p>
    </div>       
</div>